var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/WindowSideBarButtons.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Badge from '@material-ui/core/Badge';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/InfoSharp';
import AnnotationIcon from '@material-ui/icons/CommentSharp';
import AttributionIcon from '@material-ui/icons/CopyrightSharp';
import SearchIcon from '@material-ui/icons/SearchSharp';
import CanvasIndexIcon from './icons/CanvasIndexIcon';
import { keys, chars } from '../lib/KeyHelper';
/**
 *
 */

export var WindowSideBarButtons =
/*#__PURE__*/
function (_Component) {
  _inherits(WindowSideBarButtons, _Component);

  _createClass(WindowSideBarButtons, null, [{
    key: "activateTab",

    /**
     * selects the given tab
     * @param {*} tab the tab to activate
     */
    value: function activateTab(tab) {
      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', 'true');
    }
    /** */

  }]);

  function WindowSideBarButtons(props) {
    var _this;

    _classCallCheck(this, WindowSideBarButtons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSideBarButtons).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(WindowSideBarButtons, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tabBar = ReactDOM.findDOMNode(this.tabsRef); // eslint-disable-line react/no-find-dom-node

      this.tabs = Array.from(this.tabBar.querySelectorAll('button[role=tab]'));
      /*
        the change event isn't fired, when the tabs component is initialized,
        so we have to perform the required actions on our own
      */

      var selectedTab = this.tabs.find(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      }) || this.tabs[0];
      this.selectTab(selectedTab);
      selectedTab.focus();
    }
    /**
     * Set the ref to the parent tabs element
     */

  }, {
    key: "setTabsRef",
    value: function setTabsRef(ref) {
      if (this.tabsRef) return;
      this.tabsRef = ref;
    }
    /**
     * @param {object} event the change event
     * @param {string} value the tab's value
    */

  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      var addCompanionWindow = this.props.addCompanionWindow;
      var tab = event.target;
      this.selectTab(tab);
      addCompanionWindow(value);
    }
    /**
     *
     * @param {*} tab the tab to select
     */

  }, {
    key: "selectTab",
    value: function selectTab(tab) {
      WindowSideBarButtons.activateTab(tab);
      this.deactivateTabs(this.tabs.indexOf(tab));
    }
    /**
     * @param {number} omit tab index to omit
     */

  }, {
    key: "deactivateTabs",
    value: function deactivateTabs() {
      var omit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      this.tabs.map(function (v, k) {
        if (k !== omit) {
          v.setAttribute('tabindex', '-1');
          v.setAttribute('aria-selected', 'false');
        }

        return null;
      });
    }
    /**
     *
     * @param {object} event the keyUp event
     */

  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      if (event.key === keys.up || event.which === chars.up) {
        event.preventDefault();
        return this.focusPreviousTab(event.target);
      }

      if (event.key === keys.down || event.which === chars.down) {
        event.preventDefault();
        return this.focusNextTab(event.target);
      }

      return null;
    }
    /**
     * focus the previous tab
     * @param {object} tab the currently selected tab
     */

  }, {
    key: "focusPreviousTab",
    value: function focusPreviousTab(tab) {
      var previousTab = tab.previousSibling || this.tabs[this.tabs.length - 1];
      previousTab.focus();
    }
    /**
     * focus the next tab
     * @param {object} tab the currently selected tab
     */

  }, {
    key: "focusNextTab",
    value: function focusNextTab(tab) {
      var nextTab = tab.nextSibling || this.tabs[0];
      nextTab.focus();
    }
    /**
     * render
     *
     * @return {type}  description
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          hasAnnotations = _this$props.hasAnnotations,
          hasSearchResults = _this$props.hasSearchResults,
          hasSearchService = _this$props.hasSearchService,
          panels = _this$props.panels,
          sideBarPanel = _this$props.sideBarPanel,
          t = _this$props.t;
      /** */

      var TabButton = function TabButton(props) {
        return React.createElement(Tooltip, {
          title: t('openCompanionWindow', {
            context: props.value
          }),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144
          },
          __self: this
        }, React.createElement(Tab, Object.assign({}, props, {
          classes: {
            root: classes.tab,
            selected: classes.tabSelected
          },
          "aria-label": t('openCompanionWindow', {
            context: props.value
          }),
          disableRipple: true,
          onKeyUp: _this2.handleKeyUp,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 145
          },
          __self: this
        })));
      };

      return React.createElement(Tabs, {
        classes: {
          flexContainer: classes.tabsFlexContainer,
          indicator: classes.tabsIndicator
        },
        value: sideBarPanel === 'closed' ? false : sideBarPanel,
        onChange: this.handleChange,
        variant: "fullWidth",
        indicatorColor: "primary",
        textColor: "primary",
        "aria-orientation": "vertical",
        "aria-label": t('sidebarPanelsNavigation'),
        ref: function ref(_ref) {
          return _this2.setTabsRef(_ref);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158
        },
        __self: this
      }, panels.info && React.createElement(TabButton, {
        value: "info",
        icon: React.createElement(InfoIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 172
          },
          __self: this
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170
        },
        __self: this
      }), panels.attribution && React.createElement(TabButton, {
        value: "attribution",
        icon: React.createElement(AttributionIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 178
          },
          __self: this
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176
        },
        __self: this
      }), panels.canvas && React.createElement(TabButton, {
        value: "canvas",
        icon: React.createElement(CanvasIndexIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 184
          },
          __self: this
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182
        },
        __self: this
      }), panels.annotations && React.createElement(TabButton, {
        value: "annotations",
        icon: React.createElement(Badge, {
          classes: {
            badge: classes.badge
          },
          invisible: !hasAnnotations,
          variant: "dot",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 191
          },
          __self: this
        }, React.createElement(AnnotationIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          },
          __self: this
        })),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188
        },
        __self: this
      }), panels.search && hasSearchService && React.createElement(TabButton, {
        value: "search",
        icon: React.createElement(Badge, {
          classes: {
            badge: classes.badge
          },
          invisible: !hasSearchResults,
          variant: "dot",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201
          },
          __self: this
        }, React.createElement(SearchIcon, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202
          },
          __self: this
        })),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 198
        },
        __self: this
      }));
    }
  }]);

  return WindowSideBarButtons;
}(Component);
WindowSideBarButtons.defaultProps = {
  classes: {},
  hasAnnotations: false,
  hasSearchResults: false,
  hasSearchService: false,
  panels: [],
  sideBarPanel: 'closed',
  t: function t(key) {
    return key;
  }
};